import { render, staticRenderFns } from "./PatrolRecords.vue?vue&type=template&id=ee3330f4&scoped=true"
import script from "./PatrolRecords.vue?vue&type=script&lang=js"
export * from "./PatrolRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3330f4",
  null
  
)

export default component.exports